
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Group from 'vux/src/components/group/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'

export default {
components: {
Flexbox,
FlexboxItem,
XButton,
Group,
CellBox
},
methods: {
jump: function (e) {
alert(e);

}
}
}



// WEBPACK FOOTER //
// ./src/components/PersonalGroup.vue